import styled from 'styled-components';
import { ThemeProps } from '@/styles/global';

export const AutocompleteWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  box-shadow: 0 0 0.25rem rgba(16, 168, 35, 0.1);
  border: 0.25rem;
  & > div {
    width: inherit;
    height: inherit;
    & form {
      display: block;
      width: inherit;
      height: inherit;
      border: none;
      box-shadow: none;
      outline: none;
      &:focus-within {
        box-shadow: none;
      }
    }
    & .aa-InputWrapperPrefix,
    .aa-InputWrapperSuffix {
      display: none;
    }
    & .aa-InputWrapper {
      width: inherit;
      height: inherit;
      & > input {
        width: inherit;
        height: inherit;
        font-family: ${(props: ThemeProps) => props.theme.fontFamily};
        font-weight: normal;
        font-size: 1.125rem;
        color: ${(props: ThemeProps) => props.theme.blackColor};
        line-height: 1.6875rem;
        padding: 1.8125rem 53.4% 1.875rem 4.5rem;
        outline: none;
        background-color: ${(props: ThemeProps) => props.theme.whiteColor};
        border: 0.0625rem solid transparent;
        border-radius: 0.25rem;
        &:focus {
          border-color: ${(props: ThemeProps) => props.theme.softGreenColor};
        }
        @media (max-width: 768px) {
          padding: 0.75rem 1rem 0.75rem 3.25rem;
          height: 3rem;
        }
      }
    }
  }
  @media (max-width: 768px) {
    position: static;
  }
`;

export const StyledInput = styled.input`
  width: 100%;
  height: 100%;
  font-weight: normal;
  font-size: 1.125rem;
  line-height: 1.6875rem;
  padding: 1.8125rem 53.4% 1.875rem 4.5rem;
  outline: none;
  background-color: ${(props: ThemeProps) => props.theme.whiteColor};
  box-shadow: 0 0 0.25rem rgba(16, 168, 35, 0.1);
  border: 0.0625rem solid transparent;
  border-radius: 0.25rem;
  &:focus {
    border-color: ${(props: ThemeProps) => props.theme.softGreenColor};
  }
`;

export const StyledDropdownMenu = styled.div`
  max-width: 50%;
  position: relative;
  top: 0;
  z-index: 2;
  box-shadow: 0 0 0.25rem rgb(16 168 35 / 10%);
  border-radius: 0.25rem;
  background-color: ${(props: ThemeProps) => props.theme.whiteColor};
`;

export const StyledUl = styled.ul`
  list-style: none;
  padding: 0.75rem 0 1.25rem 0;
  & li {
    font-size: 1.125rem;
    padding: 0.5rem 1.5rem 0.5rem 2rem;
    cursor: pointer;
    &:hover {
      background-color: ${(props: ThemeProps) => props.theme.lightGrayColor};
    }
  }
`;
